// extracted by mini-css-extract-plugin
export default {"content":"Layout_content__qHfU7","paper":"Layout_paper__xjDwa"};